import { NewsItem } from "@/interfaces/NewsItem";
import { defineComponent, PropType } from "vue";

const maxCharCount = 275;

export default defineComponent({
  props: {
    items: { type: Array as PropType<NewsItem[]>, required: true },
  },
  setup(props) {
    const summarizeText = (text: string): string => {
      if (text.length > maxCharCount) {
        return text.substring(0, maxCharCount) + "...";
      }

      return text;
    };

    return { summarizeText };
  },
});
